import { useTranslation } from 'react-i18next';
import { getHamsterGameSourceCode } from '../vendor/get-hamster-game-source-code';

export const useGetHamsterGameCode = () => {
  const { t } = useTranslation();

  const isTouchScreen = window.matchMedia('(pointer: coarse)').matches;

  const title = isTouchScreen
    ? t('hamsterGame.gameTitleTouchscreen')
    : t('hamsterGame.gameTitle');

  return getHamsterGameSourceCode(title);
};
